import InfoWrapper from "../InfoWrapper/InfoWrapper";
const Orders = () => {
    return (
        <>
            <InfoWrapper infoHeading="Orders"></InfoWrapper>
        </>
    );
}

export default Orders;